import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';
import URL from "@core/scripts/helper/url";
import {useQuery} from "@tanstack/react-query";
import {NAVIGATION_STALE_TIME} from "../navigation/constants.js";

const fetchNavigationItems = async () => {
    const absoluteUrl = URL.toAbsolute('/ajax/navigation/mobile/');

    const response = await fetchWithCSRF(absoluteUrl, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    });

    if (!response.ok) {
        throw new Error('Failed to fetch navigation items');
    }

    return response.json();
};

const useMobileNavigation = () => {
    return useQuery({
        queryKey: ['navigation/mobile'],
        queryFn: () => fetchNavigationItems(),
        staleTime: NAVIGATION_STALE_TIME,
    });
};
export default useMobileNavigation;